<template>
  <a-card :bordered="false">
    <a-button type="primary" @click="openModel">添加供应商</a-button>
    <custom-page-table
      :queryParams="queryParams"
      style="margin-top:16px;"
      ref="tableList"
      :columns="columnsOrder"
      :requestPromise="loadPromise"
    >
      <span slot="state" slot-scope="rowItem">
        <span>{{ rowItem.record.state == 1 ? '启用' : '禁用' }}</span>
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="editEvent(rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.state==0" @click="onUpdateEvent(rowItem.record.id)">启用</a>
        <a v-else style="color:red" @click="onUpdateEvent(rowItem.record.id)">禁用</a>
      </span>
    </custom-page-table>
    <a-modal :title="id?'编辑供应商':'添加供应商'" :width="666" :afterClose="afterClose" :footer="null"
             :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="供应商名称" prop="supplierName">
          <a-input v-model.trim="ruleForm.supplierName" :maxLength="6"
                   placeholder="仅用于区分标识数据来源，6个字内"></a-input>
        </a-form-model-item>
        <a-form-model-item label="接口地址(URL)" prop="reqUrl">
          <a-input v-model.trim="ruleForm.reqUrl" placeholder="请输入" :maxLength="255"></a-input>
        </a-form-model-item>
        <a-form-model-item label="分销商 id(distributionsKey)" prop="distributionId">
          <a-input v-model.trim="ruleForm.distributionId" placeholder="请输入" :maxLength="255"></a-input>
        </a-form-model-item>
        <a-form-model-item label="公钥(publicKey)" prop="publicKey">
          <a-input v-model.trim="ruleForm.publicKey" placeholder="请输入" :maxLength="2000"></a-input>
        </a-form-model-item>
        <a-form-model-item label="私钥(privateKey)" prop="privateKey">
          <a-input v-model.trim="ruleForm.privateKey" placeholder="请输入" :maxLength="2000"></a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit" style="width: 150px;margin-right: 20px;">提交</a-button>
          <a-button @click="handleCancel">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'AccountList',
  data() {
    return {
      queryParams: {},
      columnsOrder: [
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '分销商id(distributionsKey)',
          dataIndex: 'distributionId'
        },
        {
          title: '状态',
          dataIndex: 'state',
          scopedSlots: { customRender: 'state' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '200px',
          fixed: 'right'
        }
      ],
      visible: false,
      ruleForm: {},
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      loadPromise: params => this.getListPromise(params),
      rules: {
        supplierName: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        reqUrl: [{ required: true, message: '请输入接口地址(URL)', trigger: 'blur' }],
        distributionId: [{ required: true, message: '请输入分销商 id(distributionsKey)', trigger: 'blur' }],
        publicKey: [{ required: true, message: '请输入公钥(publicKey))', trigger: 'blur' }],
        privateKey: [{ required: true, message: '请输入私钥(privateKey)', trigger: 'blur' }]
      },
      id: ''
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ProductList', title: '同步产品' },
      { name: 'AccountList', title: '关联账号' }
    ])
  },
  methods: {
    getListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      return this.getHttpServices().getServerApiService().post('fengYe/team/queryFengYeTeamAccountList', params)
    },
    handleCancel() {
      this.visible = false
    },
    submitEvent() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        ...this.ruleForm
      }
      if (this.id) {
        params.id = this.id
      }
      let msg = this.id ? '编辑成功' : '成功添加'
      this.getHttpServices().getServerApiService().post('fengYe/team/editFengYeTeamAccount', params)
        .then(res => {
          this.$message.success(msg)
          this.visible = false
          this.$refs.tableList.refresh(true)
          this.SynchronousProducts()
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    SynchronousProducts() {
      this.getHttpServices().getProService().post('direct/fengYe/syncFengYeTeamProduct', {})
        .then(res => {
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitEvent()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    afterClose() {
      this.id = ''
    },
    getDetails(id) {
      let params = {
        id: id
      }
      this.getHttpServices().getServerApiService().post('fengYe/team/findFengYeTeamAccount', params)
        .then(res => {
          this.ruleForm = res
          this.visible = true
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    openModel() {
      this.ruleForm = {}
      this.visible = true
    },
    editEvent(record) {
      this.id = record.id
      this.getDetails(record.id)
    },
    onUpdateEvent(id) {
      let params = {
        id: id
      }
      this.getHttpServices().getServerApiService().post('fengYe/team/editFengYeTeamState', params)
        .then(res => {
          this.$message.success('修改成功')
          this.$refs.tableList.refresh(true)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    }
  }
}
</script>

<style scoped>

</style>